module.exports = __webpack_public_path__ + "img/money_bag.65b77479.svg";